"use strict";
exports.__esModule = true;
exports.getColor = exports.__ = void 0;
var tslib_1 = require("tslib");
var parseToRgb_1 = tslib_1.__importDefault(require("polished/lib/color/parseToRgb"));
var __ = function (text) { return text; };
exports.__ = __;
function getColor(color, fallbackColor) {
    if (fallbackColor === void 0) { fallbackColor = '#fff'; }
    try {
        (0, parseToRgb_1["default"])(color);
        return color;
    }
    catch (e) {
        return fallbackColor;
    }
}
exports.getColor = getColor;
